<template>
  <div class="yuyueguahao">
    <!-- <van-search v-model="search" placeholder="请输入搜索门诊" @search="searchDept"/> -->
    <van-list v-model="loading" :finished="finished" class="list">
      <div v-if="doctor.length" class="doctor-list">
        <div class="list-title">医生</div>
        <van-cell v-for="item in doctor" :key="item.id" :title="item.name" is-link @click="selectDept(item)">
          <!-- <van-cell v-for="(item, index) in doctor" :key="`doctor${index}`" @click="selectDoctor(item)"> -->
          <div slot="icon">
            <img class="doctor-img" src="../../assets/images/doctor.png">
          </div>

          <div slot="title">{{ item.name }} | {{ item.title }}</div>

          <div slot="label">{{ item.deptName }}</div>

          <div slot="right-icon">
            <van-icon class="doctor-right-icon" name="arrow" />
          </div>
        </van-cell>
      </div>

      <div v-if="dept.length" class="dept-list">
        <div class="list-title">科室</div>
        <van-cell v-for="(item, index) in dept" :key="`dept${index}`" :title="item.name" is-link @click="selectDept(item)" />
      </div>
    </van-list>
    <van-dialog
      v-model="show"
      :title="deptInfo.code === '012B' ? '温馨提示' : '地点提醒'"
      :confirm-button-color="confirmButtonColor"
      :confirm-button-text="confirmButtonText"
      :before-close="beforeClose"
      @confirm="toPage"
    >
      <p v-if="deptInfo.code === '012B'" class="tips">为了更便捷地完成残疾评定，减少来回奔波，来院前请监护人到所属辖区社区提出残疾鉴定申请，并填写《鉴定申请表》，来院时携带好《鉴定申请表》、精神专科医院门诊病历、出院小结、既往评定意见等材料。</p>
      <div v-else-if="deptInfo.code==='012F02'||deptInfo.code==='012F01'">
        <p class="tips">苏州市姑苏区金太史巷4号家庭教育咨询中心</p>
      </div>
      <div v-else>
        <p class="tips">苏州人民商场新平江商业广场（人民路3189号）三楼苏州市心理卫生中心（平江中心）</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'YuYueGuaHao',
  data() {
    return {
      type: 1,
      confirmButtonText: '',
      confirmButtonColor: '',
      timer: null,
      num: 0,
      show: false,
      deptInfo: {},
      loading: false,
      finished: false,
      patientId: '',
      search: '',
      dept: [],
      doctor: []
    }
  },
  created() {
    this.type = this.$route.query.type
  },
  mounted() {
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.patientId = JSON.parse(localStorage.getItem('userInfo')).id
    } else {
      this.$router.push('/myPatient')
    }

    this.searchDept()
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    /**
     * 获取门列表
     */
    deptTreeFun() {
      this.$Apis.deptTree({ parentId: this.patientId }).then(res => {
        if (res.code === 200) {
          console.log(res)
          // this.list = res.data
        }
      })
    },

    /**
     * 搜索门诊
     */
    searchDept() {
      this.loading = true
      this.$Apis.findByKeyword({
        keyword: this.search,
        campusArea: this.type
      }).then(res => {
        this.loading = false
        this.finished = true
        if (res.code === 200) {
          this.dept = res.data.dept || []
          this.doctor = res.data.doctor || []
        }
      }).catch(() => {
        this.loading = false
        this.finished = true
      })
    },

    /**
     * 选择科室
     */
    selectDept(item) {
      /* let message = ''
      switch (item.code) {
        case '0104':
          if (new Date().getTime() < new Date('2024/5/6').getTime()) {
            message = '本门诊每天限号5个，需另收心理专家咨询费用 180/次(现由于政策调整预约2024/5/6 及后续的号源，则需另收心理专家咨询费用 270/次)(不包含其他的检查费用)'
          } else {
            message = '本门诊每天限号5个，需另收心理专家咨询费用 270/次（不包含其他的检查费用）'
          }
          break
        case '01101':
          if (new Date().getTime() < new Date('2024/5/6').getTime()) {
            message = '本门诊需另收心理咨询费180元/次(现由于政策调整预约2024/5/6 及后续的号源，则需另收心理专家咨询费用 270/次)(不包含其他的检查费用)'
          } else {
            message = '本门诊需另收心理咨询费270元/次（不包括其它检查治疗费用）'
          }
          break
        case '01084':
          message = '本门诊每次限号3人。挂号费300元/次（全自费，不含其他检查治疗费用）。建议就诊前完善好头颅CT或MRI、脑电图、心电图及血常规、生化等常规检查检验，就诊时带好所有既往病史资料。'
          break
        default:
      }
      if (message) {
        this.$dialog.alert({
          title: '提示',
          message
        }).then(() => {
          this.toDeptDetail(item)
        })
      } else {
        this.toDeptDetail(item)
      } */
      const codeList = ['012B', '010405', '0110C', '0110H', '0110D', '0110E', '0110F', '0110G', '012F02', '012F01']
      if (codeList.includes(item.code)) {
        if (item.code === '012B') {
          this.confirmButtonText = '确定'
          this.confirmButtonColor = '#000'
        } else {
          this.num = 5
          this.confirmButtonColor = '#666'
          this.confirmButtonText = `确定(${this.num}S)`
          this.timer = setInterval(() => {
            this.num--
            if (this.num === 0) {
              clearInterval(this.timer)
              this.confirmButtonText = '确定'
              this.confirmButtonColor = '#000'
            } else {
              this.confirmButtonText = `确定(${this.num}S)`
              this.confirmButtonColor = '#666'
            }
          }, 1000)
        }
        this.deptInfo = item
        this.show = true
      } else {
        this.toDeptDetail(item)
      }
    },
    toDeptDetail(item) {
      localStorage.setItem('deptInfo', JSON.stringify(item))
      this.$router.push(`/registered?id=${item.code}`)
    },

    beforeClose(action, done) {
      if (this.deptInfo.code === '012B') {
        done()
      } else {
        done(false)
      }
    },

    toPage() {
      if (this.num) return
      this.show = false
      this.$nextTick(() => {
        this.toDeptDetail(this.deptInfo)
      })
    },

    selectDoctor(item) {
      this.$router.push(`/registeredDetails?doctorCode=${item.doctorCode}&deptCode=${item.deptCode}`)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less" scoped>
  .list-title {
    color: #999999;
    padding: 10px 15px;
  }

  .doctor-img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }

  .doctor-right-icon {
    height: 50px;
    font-size: 16px;
    line-height: 50px;
    margin-left: 5px;
    color: #969799;
  }
  .tips {
    padding: 20px;
    font-size: 14px;
    line-height: 1.5;
    color: red;
  }
</style>
